import type { Action, ThunkDispatch } from '@reduxjs/toolkit';
import type { AppState } from '@redux/store';
import { logoutFnc } from '@redux/authReducer';

// `AppState` chỉ dùng làm type (erased khi build) nên import type này KHÔNG kéo runtime của
// '@redux/store' (configureStore/redux-persist) vào — tách riêng file này (không nằm trong
// GuestLoginCta.tsx, nơi có import runtime `useAppDispatch` từ '@redux/store') để test được bằng
// cách mock '@redux/authReducer' mà không phải chạy qua toàn bộ store thật.
export type GuestDispatch = ThunkDispatch<AppState, null, Action>;

/**
 * Đóng CTA rồi thoát trạng thái khách. Dùng khi khách bấm "Đăng nhập" trên popup mời đăng nhập
 * (GuestLoginCta) — export riêng khỏi component để unit test được thứ tự gọi bằng mock thuần,
 * không cần mount Dialog MUI (vitest hiện tại chạy `environment: 'node'`, không có DOM thật).
 *
 * Thứ tự bắt buộc:
 * 1) `onClose()` trước — không để dialog treo lại sau khi ProtectedRoute điều hướng sang /login.
 * 2) `dispatch(logoutFnc())` — khách đang có isLogin=true trong Redux (logInAsGuest/
 *    revalidateAuthentication đều dispatch authIn() cho token khách). Nếu gọi navigate('/login')
 *    ngay ở đây, RedirectRoute thấy isLogin vẫn true và bounce về /portal/menu-map trước khi
 *    logoutFnc kịp chạy xong (đua giữa navigate và RedirectRoute → CTA vô hiệu, đúng finding
 *    Critical của review). Phải thoát khách TRƯỚC: logoutFnc xoá cookie + dispatch authOut()
 *    (isLogin=false) → ProtectedRoute (bọc toàn bộ cây route '*', gồm cả Quick Search) tự
 *    `Navigate` sang /login theo phản ứng của Redux state — giống hệt nút "Đăng xuất" ở
 *    ProfileBox.tsx. KHÔNG tự gọi navigate() ở đây nữa: ProtectedRoute đã đảm nhiệm điều hướng
 *    một cách khai báo (declarative), nên không còn 2 nguồn điều hướng đua nhau.
 */
export const handleGuestLogin = (
  dispatch: GuestDispatch,
  // Không truyền khi chỗ gọi không có popup nào phải đóng (nút "Đăng nhập / Đăng ký" dưới bảng).
  onClose: () => void = () => {}
): void => {
  onClose();
  dispatch(logoutFnc());
};
